import monthlyCreditLimitForm from './monthlyCreditLimitForm'
export default monthlyCreditLimitForm
